import { render, staticRenderFns } from "./EducationNavList.vue?vue&type=template&id=641cb8c7&scoped=true"
import script from "./EducationNavList.vue?vue&type=script&lang=js"
export * from "./EducationNavList.vue?vue&type=script&lang=js"
import style0 from "./EducationNavList.vue?vue&type=style&index=0&id=641cb8c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641cb8c7",
  null
  
)

export default component.exports